import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

// --- ASSETS (Giữ nguyên từ mã nguồn của bạn) ---
import Laothan_lcm from "./image/lcm_tour/laothan.jpg";
import kyquansan from "./image/lcm_tour/kyquansan.jpg";
import back from "./image/lcm_tour/back.png"; 
import Samu from "./image/lcm_tour/samu.jpg";
import lungcung_w from "./image/lcm_tour/lungcung_w.png";

const BenefitSection = ({ title, children, img, isReverse = false }) => (
  <div className={`flex flex-col ${isReverse ? 'md:flex-row-reverse' : 'md:flex-row'} 
    items-stretch gap-0 my-12 overflow-hidden rounded-[40px] shadow-2xl bg-white 
    border-4 border-white w-full mx-auto`}>
    
    {/* KHỐI ẢNH: Ép tỉ lệ 1:1 (vuông) và chiếm đúng 50% chiều rộng */}
    <div className="w-full md:w-1/2 aspect-square relative overflow-hidden flex-shrink-0">
      <img 
        src={img} 
        className="absolute inset-0 w-full h-full object-cover" 
        alt="Hành trình" 
      />
    </div>
    
    {/* KHỐI NỘI DUNG: Chiều cao sẽ tự khớp theo khối ảnh vuông bên cạnh */}
    <div className="w-full md:w-1/2 p-10 md:p-16 flex flex-col justify-center bg-slate-50 overflow-y-auto">
      {title && (
        <h2 className="text-3xl md:text-5xl font-black text-sky-600 mb-6 uppercase tracking-tighter leading-none">
          {title}
        </h2>
      )}
      <div className="text-lg md:text-xl text-slate-700 leading-relaxed font-medium italic">
        {children}
      </div>
    </div>
  </div>
);

// Khối quảng cáo sản phẩm
const ProductBillboard = ({ title, img, features, isReverse = false }) => (
  <div className={`flex flex-col ${isReverse ? 'md:flex-row-reverse' : 'md:flex-row'} items-stretch gap-0 my-10 overflow-hidden rounded-[40px] shadow-2xl bg-white border-4 border-white`}>
    <div className="w-full md:w-1/2 min-h-[300px] relative">
      <img src={img} className="absolute inset-0 w-full h-full object-cover" alt="Tour Feature" />
    </div>
    <div className="w-full md:w-1/2 p-10 md:p-14 flex flex-col justify-center bg-slate-50">
      <h2 className="text-3xl md:text-5xl font-black text-sky-600 mb-2 uppercase tracking-tighter leading-none">
        {title}
      </h2>
      <div className="text-lg md:text-xl text-slate-700 leading-relaxed font-medium italic mb-6 ">
        Được ra đời từ đó là chuyến leo núi dành cho tất cả mọi người và chi phí 0 đồng để quảng bá, phát triển du lịch vùng núi cao
      </div>
      <ul className="space-y-4">
        {features.map((item, index) => (
          <li key={index} className="flex items-start gap-3 text-lg md:text-xl font-bold text-slate-700 italic">
            <span className="text-orange-500">▶</span> {item}
          </li>
        ))}
      </ul>
    </div>
  </div>
);
export default function Lcm_tour_w() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="relative min-h-screen font-sans overflow-x-hidden bg-slate-100"
         style={{ backgroundImage: `url(${back})`, backgroundAttachment: "fixed", backgroundSize: "cover" }}>
      
      <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-[1px] z-0"></div>

      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 md:px-10 py-16">
        
        {/* HEADER: KHẲNG ĐỊNH VỊ THẾ */}
        <header className="text-center mb-16 mt-16">
          <span className="text-sky-400 font-black font-bold tracking-[0.5em] uppercase text-xs mb-4 block">Since 2020</span>
          <h1 className="text-7xl md:text-9xl font-black text-white mb-4 tracking-tighter uppercase leading-none drop-shadow-2xl">
            KEEP <span className="text-sky-400 italic font-serif">GOING</span>
          </h1>
          <p className="text-lg md:text-2xl text-white/90 max-w-2xl mx-auto font-light italic leading-relaxed">
            "Hành trình thong dong đến đỉnh cao."
          </p>
        </header>

        {/* 4 MỤC QUYỀN LỢI CHIẾN LƯỢC (TẬP TRUNG VÀO KHÁCH HÀNG) */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-12 mt-6">
          <div className="bg-white p-8 rounded-[35px] shadow-xl border-t-8 border-sky-600 text-center">
            <h3 className="text-2xl font-black text-sky-600 uppercase mb-3">Hành trang nhẹ</h3>
            <p className="text-sm text-slate-600 font-bold italic">Xóa nỗi lo đau lưng vì mang vác nặng</p>
          </div>
          <div className="bg-white p-8 rounded-[35px] shadow-xl border-t-8 border-orange-500 text-center">
            <h3 className="text-2xl font-black text-orange-500 uppercase mb-3">Thong dong</h3>
            <p className="text-sm text-slate-600 font-bold italic">Lịch trình dư dả thời gian để tự do đứng lại ngắm hoa, không vội vã di chuyển.</p>
          </div>
          <div className="bg-white p-8 rounded-[35px] shadow-xl border-t-8 border-slate-900 text-center">
            <h3 className="text-2xl font-black text-slate-900 uppercase mb-3">Quãng đường ngắn</h3>
            <p className="text-sm text-slate-600 font-bold italic">Tiết kiệm sức lực cho những hoạt động khám phá, vui chơi</p>
          </div>
          <div className="bg-white p-8 rounded-[35px] shadow-xl border-t-8 border-green-600 text-center">
            <h3 className="text-2xl font-black text-green-600 uppercase mb-3">Chi phí 0 đồng</h3>
            <p className="text-sm text-slate-600 font-bold italic">Tour leo thuộc dự án xã hội phát triển du lịch nội địa. Hoàn toàn miễn phí dịch vụ</p>
          </div>
        </div>

        {/* NỘI DUNG TỰ SỰ ĐƯỢC CHỈNH THEO BỐ CỤC QUẢNG CÁO */}
        <div className="space-y-12">
          
          <BenefitSection title="Chào bạn!" img={lungcung_w}>
            CLB Leo núi Việt Nam hân hạnh được giới thiệu với bạn chuyến leo núi Keep Going, 
            truyền thống và tự hào. Bắt nguồn từ năm 2020, chúng mình hiểu cảm giác lần đầu leo núi luôn thận trọng về sức khỏe.
          </BenefitSection>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Khối nội dung ngắn - Nhấn mạnh lợi ích */}
            <div className="bg-sky-600 text-white p-10 rounded-[40px] shadow-xl flex flex-col justify-center">
              <p className="text-1xl md:text-2xl font-bold leading-snug">
                Và những công việc hỗ trợ đoàn: mang vác balo, thức ăn, nấu ăn, xây những căn nhà gỗ ngủ nghỉ và 
                đồng hành cùng thành viên đi cuối - chính là cơ hội việc làm cho đồng bào sống trên những mảnh đất cao hùng vĩ và khắc nghiệt.
              </p>
            </div>
            <div className="overflow-hidden rounded-[40px] shadow-xl border-4 border-white">
              <img src={Laothan_lcm} className="w-full h-full object-cover" alt="Leo núi" />
            </div>
          </div>

          <ProductBillboard 
            title="KEEP GOING" 
            img={Samu}
            features={[
              `Không đau lưng, trùng gối, đồng hành tốp cuối từ việc tăng cường porter hỗ trợ đoàn`,
              `Đứng lại ngắm một nhành hoa rừng mà không lo lắng thời gian.`,
              `Hành trình leo ngắn hơn bằng cách tận dụng những chuyến xe ôm xuyên bản làng hoang sơ.`,
              `Đến homestay chân núi ngủ 1 đêm trước khi leo, ăn sáng tại bản thay vì ngủ trên xe, gấp gáp di chuyển`
            ]}
          />

          {/* Triết lý: Keep Going */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 my-16">
            <div className="bg-white p-10 rounded-[40px] shadow-xl border-b-8 border-sky-600">
              <span className="text-5xl mb-6 block text-sky-600 font-black">Chi phí</span>
              <h3 className="text-2xl font-black uppercase mb-4">Chia đều thành viên</h3>
              <p className="text-slate-600 font-bold italic">Minh bạch và công khai</p>
            </div>
            <div className="bg-slate-900 text-white p-10 rounded-[40px] shadow-xl border-b-8 border-orange-500">
              <span className="text-5xl mb-6 block text-orange-500 font-black">Dẫn đoàn</span>
              <h3 className="text-2xl font-black uppercase mb-4">CLB Leo núi Việt Nam</h3>
              <p className="text-white/70 font-bold italic">Người bạn kinh nghiệm luôn sẵn lòng lắng nghe bạn</p>
            </div>
            <div className="bg-sky-600 text-white p-10 rounded-[40px] shadow-xl border-b-8 border-white">
              <span className="text-5xl mb-6 block text-white font-black">Số lượng</span>
              <h3 className="text-2xl font-black uppercase mb-4">06 chuyến/năm.</h3>
              <p className="text-white/90 font-bold italic">Chuyến đi được tổ chức trong suốt mùa leo núi, bắt đầu từ tháng 
                09 năm trước đến tháng 05 năm sau</p>
            </div>
          </div>
          <BenefitSection title="" img={kyquansan}>
            <button 
            onClick={() => window.open("https://forms.gle/Z35nDAkv5e5MWAha6")}
            className="group w-full mb-6 max-w-2xl bg-orange-500 hover:bg-slate-900 text-white p-6 rounded-[40px] shadow-2xl transition-all active:scale-95 border-b-8 border-orange-700"
          >
            <span className="text-3xl md:text-5xl font-black uppercase tracking-tighter block mb-2 transition-all group-hover:tracking-widest italic">
              Đăng ký ngay 
            </span>
          </button>
            Vì bước chân đầu tiên luôn là bước chân quan trọng nhất. Leo núi đơn giản là bắt đầu và không
             bỏ cuộc. Chúng mình lo liệu phần hậu cần khó khăn nhất, để bạn chỉ cần tập trung vượt qua 
             chính mình.
          </BenefitSection>
          {/* PHONG CÁCH 3: FEATURE CARDS */}
          
        </div>

        {/* NÚT HÀNH ĐỘNG MẠNH MẼ */}
        <div className="mt-16 flex justify-center">
          
        </div>
        <footer className="mt-24 text-slate-500 text-[10px] font-black tracking-[0.5em] uppercase text-center opacity-60">
          Keep Going Trek — Since 2020 — The Healing Sip 
        </footer>
      </div>
    </div>
  );
}